import { render, staticRenderFns } from "./WellbeingAnswers.vue?vue&type=template&id=ba19099a&scoped=true&"
import script from "./WellbeingAnswers.vue?vue&type=script&lang=js&"
export * from "./WellbeingAnswers.vue?vue&type=script&lang=js&"
import style0 from "./WellbeingAnswers.vue?vue&type=style&index=0&id=ba19099a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba19099a",
  null
  
)

export default component.exports